import { GIPIAbstractDTO, GIPIUuid } from "@gipisistemas/ng-core";

export class FinancialCheckReceivedCreditClientDTO extends GIPIAbstractDTO {

    /**
     * Conta
     * @Min 0 characters
     * @Max 20 characters
     */
    account: string;

    /**
     * Dígito da conta
     * @Min 0 characters
     * @Max 5 characters
     */
    accountDigit: string;

    /**
     * Agência
     * @Min 0 characters
     * @Max 20 characters
     */
    agency: string;

    /**
     * Dígito da agência
     * @Min 0 characters
     * @Max 5 characters
     */
    agencyDigit: string;

    /** @Required Valor */
    amount: number;

    /** Id do banco */
    bankId: GIPIUuid

    /** @Required Número do cheque */
    checkNumber: number;

    /** Observação */
    comments: string;

    /**
     * @Required Cpf ou Cnpj do Emitente
     * @Min 11 characters
     * @Max 14 characters
     */
    cpfOrCnpjIssuer: string;

    /** @Required Data de vencimento */
    dueDate: Date;

    /** @Required Data de emissão */
    issuanceDate: Date;

    /**
     * @Required Nome do emitente
     * @Min 3 characters
     * @Max 150 characters
     */
    issuerName: string;

    /** Número de telefone para contato */
    phone: string;

    constructor(id?: GIPIUuid) {
        super();
        this.id = id;
    }

}
